import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Instagram, ExternalLink } from 'lucide-react';

const LOGO_URL = "/heft-logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const gymLocations = [
    { name: "Anytime Fitness Leyton", tag: "Base", url: "https://maps.google.com/?q=Anytime+Fitness+Leyton+London" },
    { name: "Power Up Centre of Excellence", url: "https://maps.google.com/?q=Power+Up+Centre+of+Excellence+London" },
    { name: "Fantastic Creatures", url: "https://maps.google.com/?q=Fantastic+Creatures+Gym+London" },
  ];

  return (
    <footer className="bg-[#1A1A1A] text-white">
      {/* Main Footer */}
      <div className="container py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img 
              src={LOGO_URL} 
              alt="Heft Training" 
              className="h-16 md:h-20 w-auto mb-6 invert"
            />
            <p className="body-small text-gray-400 mb-6 max-w-xs">
              Personal training in East London. Building strength, confidence, and sustainable fitness habits that fit real life.
            </p>
            <a
              href="https://instagram.com/A.thept"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.15em] uppercase text-gray-400 hover:text-[#C9A962] transition-colors duration-300"
            >
              <Instagram size={16} />
              @A.thept
            </a>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.15em] uppercase text-[#C9A962] mb-6">Navigation</h4>
            <ul className="space-y-4">
              {[
                { path: '/about', label: 'About AJ' },
                { path: '/services', label: 'Coaching' },
                { path: '/pricing', label: 'Pricing' },
                { path: '/results', label: 'Results' },
                { path: '/contact', label: 'Contact' },
              ].map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="text-sm text-gray-400 hover:text-white transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Locations with Links */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.15em] uppercase text-[#C9A962] mb-6">Training Locations</h4>
            <ul className="space-y-4">
              {gymLocations.map((location, index) => (
                <li key={index}>
                  <a 
                    href={location.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-gray-400 hover:text-white transition-colors duration-300 inline-flex items-center gap-2"
                  >
                    {location.name}
                    {location.tag && <span className="text-[10px] bg-[#C9A962] text-[#1A1A1A] px-1.5 py-0.5 font-semibold">{location.tag}</span>}
                    <ExternalLink size={12} className="opacity-50" />
                  </a>
                </li>
              ))}
              <li className="text-sm text-gray-400">Outdoor Sessions</li>
              <li className="text-sm text-gray-400">In-Home Training</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.15em] uppercase text-[#C9A962] mb-6">Get In Touch</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#C9A962] mt-1 flex-shrink-0" />
                <span className="text-sm text-gray-400">East London, Leyton</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-[#C9A962] mt-1 flex-shrink-0" />
                <a 
                  href="mailto:enquiry@hefttraining.co.uk" 
                  className="text-sm text-gray-400 hover:text-white transition-colors duration-300"
                >
                  enquiry@hefttraining.co.uk
                </a>
              </li>
            </ul>
            <Link
              to="/contact"
              className="inline-block mt-8 btn-gold"
            >
              Book Consultation
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-500">
            © {currentYear} Heft Training. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/contact" className="text-xs text-gray-500 hover:text-white transition-colors duration-300">
              Privacy Policy
            </Link>
            <Link to="/contact" className="text-xs text-gray-500 hover:text-white transition-colors duration-300">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
